export const LOAD_CALENDAR = "load_calendar";
export const LOAD_CALENDAR_SUCCESSFUL = "load_calendar_successful";
export const LOAD_CALENDAR_ERROR = "load_calendar_error";


export const LOAD_GAMES_TABLE = "load_games_table";
export const LOAD_GAMES_TABLE_SUCCESSFUL = "load_games_table_successful";
export const LOAD_GAMES_TABLE_ERROR = "load_games_table_error";